import { Flex, Text } from "@chakra-ui/react";
import React from "react";

const ReviewCardIllustration: React.FC = () => (
  <svg
    width="174"
    height="129"
    viewBox="0 0 174 129"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.0947 72.3833V73.9949" stroke="#D3D8DE" strokeLinecap="round" />
    <path
      d="M12.4331 73.2563L13.7653 74.6119"
      stroke="#D3D8DE"
      strokeLinecap="round"
    />
    <path d="M10.875 76.865H12.7587" stroke="#D3D8DE" strokeLinecap="round" />
    <path
      d="M12.2808 80.5379L13.6129 79.1823"
      stroke="#D3D8DE"
      strokeLinecap="round"
    />
    <path d="M16.0947 80.9782V79.3666" stroke="#D3D8DE" strokeLinecap="round" />
    <path
      d="M18.8115 79.9039L17.7246 78.8296"
      stroke="#D3D8DE"
      strokeLinecap="round"
    />
    <path
      d="M19.8984 73.4577L18.8115 74.5321"
      stroke="#D3D8DE"
      strokeLinecap="round"
    />
    <path d="M20.9857 77.2179H19.3555" stroke="#D3D8DE" strokeLinecap="round" />
    <path d="M82.9985 17.5095V18.5839" stroke="#D3D8DE" strokeLinecap="round" />
    <path d="M79.769 20.7555H80.8559" stroke="#D3D8DE" strokeLinecap="round" />
    <path d="M82.9985 23.9557V22.8814" stroke="#D3D8DE" strokeLinecap="round" />
    <path d="M85.7158 20.7326H84.6289" stroke="#D3D8DE" strokeLinecap="round" />
    <path
      d="M116.902 109.65C118.2 109.65 119.254 110.691 119.254 111.976C119.254 113.26 118.2 114.301 116.902 114.301C115.603 114.301 114.55 113.26 114.55 111.976"
      stroke="#E5E7EA"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.7 80.632C149.096 80.2013 151.237 78.5131 151.732 76.6967C152.182 78.3023 154.065 80.2013 155.765 80.345C153.852 81.0147 152.023 83.004 151.732 84.5668C151.535 82.9739 149.005 80.8642 147.7 80.632"
      fill="#E5E7EA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.562 26.2876C24.562 27.2839 23.7454 28.0908 22.7383 28.0908C21.7307 28.0908 20.9146 27.2839 20.9146 26.2876C20.9146 25.2918 21.7307 24.4844 22.7383 24.4844C23.7454 24.4844 24.562 25.2918 24.562 26.2876"
      fill="#D3D8DE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M158.05 45.15C158.05 46.3376 157.238 47.3 156.237 47.3C155.236 47.3 154.425 46.3376 154.425 45.15C154.425 43.9624 155.236 43 156.237 43C157.238 43 158.05 43.9624 158.05 45.15"
      fill="#E5E7EA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.8982 121.19C50.8982 122.023 50.2159 122.698 49.3739 122.698C48.5324 122.698 47.8501 122.023 47.8501 121.19C47.8501 120.358 48.5324 119.683 49.3739 119.683C50.2159 119.683 50.8982 120.358 50.8982 121.19Z"
      stroke="#D3D8DE"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.4882 14.7032C50.4882 15.6995 49.6716 16.5064 48.6645 16.5064C47.6574 16.5064 46.8408 15.6995 46.8408 14.7032C46.8408 13.7074 47.6574 12.9 48.6645 12.9C49.6716 12.9 50.4882 13.7074 50.4882 14.7032Z"
      stroke="#D3D8DE"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.177 109.47C158.011 109.909 156.707 109.33 156.264 108.178C155.821 107.026 156.406 105.736 157.571 105.298C158.736 104.859 160.04 105.438 160.484 106.59C160.928 107.742 160.342 109.032 159.177 109.47Z"
      stroke="#E5E7EA"
      strokeLinecap="round"
    />
    <path
      d="M117.33 30.951L45.6673 40.6653C41.898 41.1762 39.2739 44.6108 39.8064 48.3366L46.9168 98.0898C47.4493 101.816 50.9366 104.422 54.706 103.911L126.369 94.1965C130.138 93.6856 132.762 90.251 132.23 86.5251L125.12 36.772C124.587 33.0462 121.1 30.44 117.33 30.951Z"
      fill="#CED0D3"
    />
    <path d="M56.1171 100.895L52.9783 113.544L68.2482 99.2506" fill="#CED0D3" />
    <path
      d="M113.55 28.1405L41.8871 37.8548C38.1177 38.3658 35.4937 41.8003 36.0261 45.5262L43.1365 95.2793C43.669 99.0051 47.1563 101.611 50.9257 101.1L122.589 91.3861C126.358 90.8751 128.982 87.4405 128.45 83.7147L121.339 33.9615C120.807 30.2357 117.32 27.6296 113.55 28.1405Z"
      fill="#EDEEF0"
    />
    <path d="M53.9677 98.7648L50.8289 111.414L66.0988 97.1203" fill="#EDEEF0" />
    <path
      opacity="0.4"
      d="M96.5253 42.5063L48.6875 49.0413C47.7439 49.1702 47.0866 50.0335 47.2194 50.9695C47.3521 51.9055 48.2246 52.5598 49.1682 52.4309L97.006 45.8958C97.9496 45.7669 98.6069 44.9037 98.4741 43.9677C98.3414 43.0317 97.4689 42.3774 96.5253 42.5063Z"
      fill="#808B97"
    />
    <path
      opacity="0.3"
      d="M111.383 49.0461L49.8765 57.4527C48.9329 57.5817 48.2756 58.4454 48.4083 59.3819C48.5411 60.3184 49.4136 60.973 50.3572 60.8441L111.864 52.4375C112.808 52.3085 113.465 51.4448 113.332 50.5083C113.2 49.5718 112.327 48.9172 111.383 49.0461Z"
      fill="#808B97"
    />
    <path
      opacity="0.3"
      d="M90.3604 60.5039L51.0659 65.8696C50.1223 65.9984 49.465 66.8613 49.5978 67.7969C49.7305 68.7325 50.603 69.3865 51.5466 69.2576L90.8411 63.8919C91.7847 63.7631 92.442 62.9002 92.3092 61.9646C92.1765 61.029 91.304 60.375 90.3604 60.5039Z"
      fill="#808B97"
    />
    <path
      d="M55.7064 80.9273L57.4456 83.3143L60.5327 83.4224L58.637 85.775L59.6284 88.7871L56.6674 87.6134L54.15 89.5256L54.2543 86.3659L51.7673 84.604L54.7065 83.6835L55.7064 80.9273Z"
      fill="#C1C6CC"
    />
    <path
      d="M66.6918 79.4222L68.431 81.8091L71.518 81.9173L69.6223 84.2699L70.6137 87.282L67.6527 86.1083L65.1353 88.0205L65.2396 84.8607L62.7526 83.0989L65.6918 82.1784L66.6918 79.4222Z"
      fill="#C1C6CC"
    />
    <path
      d="M77.6776 77.9165L79.4168 80.3034L82.5039 80.4115L80.6082 82.7642L81.5996 85.7762L78.6386 84.6025L76.1212 86.5147L76.2255 83.355L73.7385 81.5932L76.6776 80.6727L77.6776 77.9165Z"
      fill="#C1C6CC"
    />
    <path
      d="M88.663 76.411L90.4022 78.798L93.4892 78.9062L91.5935 81.2588L92.5848 84.2708L89.6239 83.0971L87.1064 85.0093L87.2108 81.8496L84.7238 80.0877L87.663 79.1672L88.663 76.411Z"
      fill="#C1C6CC"
    />
    <path
      d="M99.6488 74.9053L101.388 77.2923L104.475 77.4004L102.579 79.7531L103.571 82.7651L100.61 81.5914L98.0922 83.5036L98.1966 80.3438L95.7096 78.5819L98.6488 77.6615L99.6488 74.9053Z"
      fill="#C1C6CC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M126.693 11.1898C127.342 11.2887 127.759 11.8704 127.624 12.489L125.896 20.4304C125.761 21.049 125.126 21.4703 124.478 21.3714C123.829 21.2724 123.412 20.6908 123.547 20.0722L125.275 12.1308C125.41 11.5122 126.045 11.0909 126.693 11.1898Z"
      fill="#E5E7EA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M132.237 33.7932C132.375 33.0777 132.989 32.5923 133.607 32.709L141.549 34.2076C142.168 34.3243 142.557 34.999 142.419 35.7146C142.281 36.4301 141.667 36.9155 141.049 36.7988L133.107 35.3002C132.489 35.1835 132.099 34.5088 132.237 33.7932Z"
      fill="#E5E7EA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.072 13.8911C111.609 13.5119 112.313 13.6342 112.645 14.1643L116.886 20.944C117.217 21.474 117.051 22.2111 116.514 22.5903C115.977 22.9694 115.273 22.8471 114.942 22.3171L110.701 15.5374C110.369 15.0073 110.536 14.2703 111.072 13.8911Z"
      fill="#E5E7EA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M139.742 20.0122C140.074 20.5423 139.907 21.2794 139.37 21.6585L132.503 26.5083C131.966 26.8875 131.262 26.7652 130.93 26.2351C130.599 25.7051 130.765 24.968 131.302 24.5888L138.169 19.739C138.706 19.3599 139.41 19.4822 139.742 20.0122Z"
      fill="#E5E7EA"
    />
  </svg>
);

type AiInterviewerInsightsEmptyStateProps = {
  /** True when the rating summary has zero reviews with no date filter (all time). */
  noReviewsEver: boolean;
};

export const AiInterviewerInsightsEmptyState: React.FC<
  AiInterviewerInsightsEmptyStateProps
> = ({ noReviewsEver }) => (
  <Flex alignItems="center" justifyContent="center" pt="120px" px={3}>
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap={6}
      width="100%"
      maxWidth="600px"
      px={3}
    >
      <Flex direction="column" alignItems="center" gap={4} width="100%">
        <ReviewCardIllustration />
        <Flex direction="column" alignItems="center" gap={2} width="100%">
          <Text
            fontSize="20px"
            lineHeight="28px"
            fontWeight="700"
            color="#393F47"
            textAlign="center"
          >
            {noReviewsEver
              ? "No candidate feedback yet"
              : "No candidate feedback in this date range"}
          </Text>
          <Text
            fontSize="16px"
            lineHeight="24px"
            fontWeight="400"
            color="#67717E"
            textAlign="center"
          >
            {noReviewsEver ? (
              <>
                Once candidates complete interviews with this AI interviewer,
                you&apos;ll see feedback ratings, comments, and AI-generated
                insights here
              </>
            ) : (
              <>Try selecting a wider date range above.</>
            )}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  </Flex>
);

export default AiInterviewerInsightsEmptyState;
